import { render, staticRenderFns } from "./ListLifts.vue?vue&type=template&id=7755ae74&scoped=true"
import script from "./ListLifts.vue?vue&type=script&lang=js"
export * from "./ListLifts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7755ae74",
  null
  
)

export default component.exports